import React from 'react';
import { IconType } from 'react-icons';
import { MdImage, MdPictureAsPdf } from 'react-icons/md';
import { IoDocument, IoDocumentText } from 'react-icons/io5';

export type DocumentIconProps = Omit<Parameters<IconType>[0], 'size'> & {
  size: string;
  /**
   * The file extension (not including the dot), e.g. 'pdf'. Determines which document icon to display.
   */
  ext: string;
};

/**
 * Displays a document icon that is appropriate for the provided file extension.
 */
export const DocumentIcon: React.FC<DocumentIconProps> = ({
  ext,
  size,
  ...otherProps
}): ReturnType<IconType> | null => {
  const IconComponent = (ext => {
    if (/^doc/.test(ext)) {
      return IoDocumentText;
    }
    if (/^pdf$/.test(ext)) {
      return MdPictureAsPdf;
    }
    if (/^png$/.test(ext)) {
      return MdImage;
    }
    return IoDocument;
  })(ext);

  return <IconComponent size={size} {...otherProps} />;
};
